import { Grade, Class, Group } from '../../../../../schoolmanagement/src/app/model/school.model';

export class ContentData {
  _id: string;
  media: any;
  media_id: string;
  media_name: string;
  media_url: string;
  media_type: string;
  media_mime_type: string;
  title: string;
  published: string;
  description: string;
  duration: number;
  status: string;
  tags: string[] = [];
  published_to: any;
  subject: Subject;
  topic: Topic;
  start_year: Year;
  end_year: Year;
  start_grade: Grade;
  end_grade: Grade;
  source: Source;
  language: Language;
  yearRange: YearRange;
  favorite: boolean;
  classes?: Class[] = [];
  groups?: Group[] = [];
}

class Subject {
  _id: string;
  name: string;
}
class Topic {
  _id: string;
  name: string;
  subject_id: string;
}

class Year {
  _id: string;
  name: string;
  description: string;
  category: string;
  number: number;
}

class YearRange {
  start: number;
  end: number;
}

class Source {
  _id: string;
  name: string;

}
class Language {
  _id: string;
  name: string;
}

export class PublishTo {
  all: boolean;
  projects: string[];
}
